(function (angular, app) {
   "use strict";

   angular.module(app.modules.common.name)
      .factory(app.modules.common.services.eventbus, EventFactory);
   
   EventFactory.$inject = ["$rootScope"];
   
   function EventFactory($rootScope) {
      
      //##//--------------------------------------- 
      
      var subscribe = function (eventName, callback) {
         return $rootScope.$on(eventName, callback);
      },

      broadcast = function (eventName, data) {
         $rootScope.$emit(eventName, data);
      };
      
      //##//--------------------------------------- 

      var service = {
         subscribe: subscribe,
         broadcast: broadcast
      };
      
      return service;
   }
   
}(angular, app));
